module.exports = __webpack_public_path__ + "img/formsTrapezSER.140f0414.svg";